import React from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import { PageBody } from "../../../common/components/PageBody/PageBody";
import { PageMessage } from "../../../common/components/PageMessage/PageMessage";
import { useZerezesServices } from "../../../providers/ZerezesServicesProvider";
import { SearchMemberAccount } from "../../../domain/models/SearchMemberAccount";
import { useZerezesClubAccount } from "../../../providers/ZerezesClubAccountProvider";
import { SearchOutput } from "../../../common/models/SearchOutput";
import { Loading } from "../../../common/components/Loading/Loading";

export const ZClubAccountPageBodySearch = () => {

  const [list, setList] = React.useState<SearchMemberAccount[]>([]);
  const [searchInfo, setSearchInfo] = React.useState<SearchOutput>({
    currentPage: 0,
    currentPageSize: 0,
    amountOfPages: 0,
    totalAmount: 0
  });
  const [customerEmail, setCustomerEmail] = React.useState<string>('');
  const [message, setMessage] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const searchInputRef = React.useRef<HTMLInputElement>(null);
  const currentPageRef = React.useRef<number>(1);
  const listContainerRef = React.useRef<HTMLDivElement>(null);

  const {
    ztoken,
    selectMemberAccount,
    memberAccountGroupData,
    refresh,
    clearZParams
  } = useZerezesClubAccount();

  const {
    searchMemberAccountService,
    alertService
  } = useZerezesServices();

  React.useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  const renderList = () => {
    const rlist: any[] = [];

    rlist.push(...list?.map((item, index) => {
      return (
        <Card key={index} style={{ marginBottom: '10px' }}>
          <Card.Body style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column', paddingRight: '10px', flex: 1 }}>
              <div style={{ wordBreak: 'break-word', fontSize: '0.8em' }}>
                <strong>{item.email}</strong>
              </div>
              <div>{item?.name || ''}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Button onClick={() => selectMemberAccount(item.shopifyId)} disabled={loading} variant='primary'>
                Acessar
              </Button>
            </div>
          </Card.Body>
        </Card>
      )
    }) || []);

    if (searchInfo?.amountOfPages && searchInfo?.amountOfPages > currentPageRef.current) {
      rlist.push(
        <div key="load-more" style={{ textAlign: 'center', marginTop: '10px' }}>
          <Button
            variant='primary'
            onClick={() => {
              currentPageRef.current += 1;
              handleSearch();
            }}
            disabled={loading}
          >
            Carregar mais ...
          </Button>
        </div>
      );
    }

    return rlist;
  };

  return (
    <PageBody>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', height: 'calc(100dvh - 100px)' }}>
        <div>
          <InputGroup>
            {memberAccountGroupData?.memberAccount &&
              <Button variant='primary' title='Voltar' onClick={refresh} disabled={loading}>
                <FontAwesomeIcon icon={faArrowLeft} color={'var(--primary-text-color)'} />
              </Button>
            }
            <Form.Control
              type={'email'}
              placeholder={'Informe o e-mail do cliente e clique em Localizar à direita ->'}
              defaultValue={customerEmail}
              onChange={(e) => setCustomerEmail(e.target.value)}
              onKeyDown={(e) => { e.key === 'Enter' && handleSearch(true) }}
              autoFocus
              disabled={loading}
              ref={searchInputRef}
              style={{ padding: '0.6rem 0.7rem' }}
            />
            <Button variant='primary' title='Localizar' onClick={() => handleSearch(true)} disabled={loading}>
              <FontAwesomeIcon icon={faSearch} color={'var(--primary-text-color)'} />
            </Button>
          </InputGroup>

          {message ? <div style={{ marginTop: '10px' }}><PageMessage text={message} /></div> : null}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflowY: 'auto' }} ref={listContainerRef}>
          {renderList()}
        </div>
      </div>
    </PageBody>
  );

  function handleSearch(restart = false) {
    console.log(`searching by ${customerEmail}...`);
    if (restart) {
      console.log('restarting search...');
      currentPageRef.current = 1;
    }
    console.log(`current page: ${currentPageRef.current}`);

    if (!customerEmail) {
      setMessage('Informe o e-mail do cliente!');
      return;
    }

    if (customerEmail.length < 4) {
      setMessage('O e-mail informado é muito curto. Informe um e-mail válido.');
      return;
    }

    setLoading(true);
    setMessage(null);

    searchMemberAccountService?.handle({
      email: customerEmail,
      currentPage: currentPageRef.current,
      pageSize: 10
    }, ztoken || '')
      .then((result) => {
        const currentList = result?.value?.list || [];
        const newList = restart ? [...currentList] : [...list, ...currentList];
        setList(newList);
        if (newList.length === 0) {
          setMessage('Nenhum cliente encontrado com o e-mail informado.');
        }
        setSearchInfo({
          currentPage: result?.value?.currentPage,
          currentPageSize: result?.value?.currentPageSize,
          amountOfPages: result?.value?.amountOfPages,
          totalAmount: result?.value?.totalAmount
        });
        if (currentPageRef.current > 1 && listContainerRef.current) {
          setTimeout(() => {
            listContainerRef?.current?.scrollTo({
              top: listContainerRef.current.scrollTop + ((76+10)*3) + 58,
              behavior: 'smooth'
            });
          }, 500);
        } else if (currentPageRef.current <= 1 && listContainerRef.current) {
          setTimeout(() => {
            listContainerRef?.current?.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }, 500);
        }
      })
      .catch((error) => {
        if (error?.action == 'logout-login') {
          alertService?.warning('Realize login novamente e tente localizar o cliente. Se não funcionar avise o time tech zrzs.');
          clearZParams && clearZParams();
          return;
        }
        setMessage('Não foi possível localizar o cliente. Tente novamente e se o problema persistir fale com o time tech zrzs.');
      })
      .finally(() => {
        setLoading(false);
        /*setTimeout(() => {
          searchInputRef.current?.focus();
        }, 500);*/
      });
  }

}